import { TrendingUpOutlined } from '@mui/icons-material'
import  { useEffect, useState } from 'react'
import {db} from '../firebase'

function useObtenerDatosdeCliente(uid){
  

  const [data, setData] = useState(null)
  const [userdata,setUserdata] = useState(null)
  const [loadingDatosdeCliente, setLoading] = useState(false)
  const [errorDatosdeCliente, setError] = useState(null)

  useEffect(()=>{
    fetchData(uid)
  },[uid])


  const fetchData = async (id) => {
    try {
      setLoading(TrendingUpOutlined)
      const accountants = await db.collection(`${process.env.REACT_APP_COL_USERS}`)
      .doc(id)
      .get();
      var dataResult = accountants.data();
      //console.log(dataResult)
      setUserdata(dataResult)
      const companiesaccountants = await db.collection(`${process.env.REACT_APP_COL_COMPANIES}`)
      .doc(dataResult.userCompanyID)
      .get();
      var dataComp = companiesaccountants.data();
  //    console.log(dataComp)
      setData(dataComp)
      setLoading(false)
      setError(false)
    } catch (error) {
      console.log('error')
      setError(true)
    }
  }

  return {userdata, data, loadingDatosdeCliente, errorDatosdeCliente}

}

export default useObtenerDatosdeCliente